import { StatsPeriods } from "../../../components/pages/connected/Dashboard/DashboardResults/DashboardResults.types"

export const getPeriodLabel = (period: StatsPeriods) => {
  switch (period) {
    case StatsPeriods.Day:
      return 'Jour'
    case StatsPeriods.Week:
      return 'Semaine'
    case StatsPeriods.Month:
      return 'Mois'
    case StatsPeriods.Custom:
      return 'Période personalisée'
  }
}